import net from "../Assets/svg/icon/net.svg";

export const superFinancialMenuItems = [{
    id: 3,
    menu_title: "defaultCharges",
    menu_icon: net,
    active: true,
    path: "/admin/financial/defaultCharges",
},{
    id: 2,
    menu_title: "defaultPanel",
    menu_icon: net,
    active: true,
    path: "/admin/financial/defaultPanel",
},{
    id: 1,
    menu_title: "transactions",
    menu_icon: net,
    active: true,
    path: "/admin/financial/transactions",
}]